import type { SVGProps } from 'react'

export const EmptyList = (props: SVGProps<SVGSVGElement>) => (
  <svg width="261" height="122" viewBox="0 0 261 122" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="93" height="31" rx="15.5" fill="#E1E5ED" />
    <rect x="106" width="117" height="31" rx="15.5" fill="#E1E5ED" />
    <rect y="44" width="65" height="33" rx="16.5" fill="#E1E5ED" />
    <rect y="90" width="112" height="32" rx="16" fill="#E1E5ED" />
    <rect x="78" y="44" width="110" height="33" rx="16.5" fill="#E1E5ED" />
    <rect x="120" y="90" width="86" height="32" rx="16" fill="#E1E5ED" />
    <circle cx="193" cy="44" r="29" stroke="#6224C6" strokeWidth="8" />
    <path
      d="M254.172 110.828C255.734 112.391 258.266 112.391 259.828 110.828C261.391 109.266 261.391 106.734 259.828 105.172L254.172 110.828ZM214 65L211.172 67.8284L254.172 110.828L257 108L259.828 105.172L216.828 62.1716L214 65Z"
      fill="#6224C6"
    />
  </svg>
)
